<div class="filter-box card">
  <div class="row align-items-center">
    <div class="col-md-3">
      <div class="input-group stc-input-group custom-input mb-3">
        <span class="input-group-text" id="basic-addon1"
          ><i class="fas fa-search"></i
        ></span>
        <input
          type="text"
          matInput
          #input
          placeholder="{{ 'search_for_user' | translate }}"
          class="form-control stc-input"
          (keyup)="searchFilter($event)"
        />
      </div>
    </div>
    <div class="col-md-7">
      <div class="row">
        <!-- <div class="col-md-4">
          <stc-apps-select-drop-down
            [label]="'Job title'"
            [selectType]="'filter-select-box'"
            [options]="jobs"
          ></stc-apps-select-drop-down>
        </div> -->
        <div class="col-md-5">
          <stc-apps-select-drop-down
            [label]="'privilege'"
            [selectType]="'filter-select-box'"
            [options]="privilages"
          ></stc-apps-select-drop-down>
        </div>
        <div class="col-md-5">
          <stc-apps-select-drop-down
            [label]="'team'"
            [selectType]="'filter-select-box'"
            [options]="teams"
          ></stc-apps-select-drop-down>
        </div>
      </div>
    </div>
    <div class="col-md-2">
      <stc-apps-button
        [buttonText]="addBtnLabel"
        [buttonType]="'primary'"
        [buttonIcon]="' fa-plus-circle'"
        (btnClick)="onAddClick()"
      ></stc-apps-button>
    </div>
  </div>
</div>
